import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

const catsCarousel = document.querySelectorAll(".carousel-categories");

catsCarousel?.forEach((carousel) => {
  const paginationElement = carousel.querySelector(".swiper-pagination");
  const arrowPrev = carousel.querySelector(".previous");
  const arrowNext = carousel.querySelector(".next");
  const swiper = carousel.querySelector(".swiper");
  const totalSlides = swiper.querySelectorAll(".swiper-slide").length;

  // Check if boxed layout (check if any slide has .boxed class)
  const isBoxed = swiper.querySelector(".swiper-slide a.boxed") !== null;

  // Always use 8 for boxed, 6 for non-boxed
  const slidesPerViewDesktop = isBoxed ? 8 : 6;

  new Swiper(swiper, {
    modules: [Navigation, Pagination],
    slidesPerView: 2,
    spaceBetween: 20,
    slidesPerGroup: 2,
    breakpoints: {
        640: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
      1280: {
        slidesPerView: slidesPerViewDesktop,
        spaceBetween: 20,
      },
    },
    navigation: {
      nextEl: arrowNext,
      prevEl: arrowPrev,
    },
    pagination: {
      el: paginationElement,
      clickable: true,
    },
  });
});
